import { ColumnDef } from "@tanstack/react-table"
import { getTotalsValue } from ".."
import { ColumnDefinition, TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"
import SearchTotals from "../../../../../../state/search/SearchTotals"

export default (columnDefinition: ColumnDefinition, totals: SearchTotals | undefined): Partial<ColumnDef<TableRowData>> => ({
    footer: () => getTotalsValue(columnDefinition.totalAttributes?.key ?? "", totals)
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/total-mappers/StringTotalMapper.tsx